function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.473 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.125 10.277V2.3L9.43 1.53v7.979l.1.026zm-4.041-.753V1.582l-2.547.849q-.073.024-.148.045v7.942l2.547-.849q.073-.024.148-.045zm-4.042.945L1.347 9.7V1.723l2.6.742.1.026zM1.717.428A1.347 1.347 0 0 0 0 1.723V9.7A1.347 1.347 0 0 0 .977 11l3.338.954a1.347 1.347 0 0 0 .8-.017l3.251-1.084a1.347 1.347 0 0 1 .8-.017l2.6.742a1.347 1.347 0 0 0 1.717-1.3V2.3a1.347 1.347 0 0 0-.977-1.3L9.158.052a1.347 1.347 0 0 0-.8.017L5.111 1.153a1.347 1.347 0 0 1-.8.017z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.a5f5bde2.svg";
export { ForwardRef as ReactComponent };